import React from 'react'

const UiManagement = () => {
  return (
    <div>
      <h1>UI Management</h1>
    </div>
  )
}

export default UiManagement
